import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-radio-button',
    templateUrl: './radio-button.component.html',
    styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent {
    @Input() nameForIsolation: string;
    @Input() largeBlock = false;
    @Input() label: string;
    @Input() labelFontWeight: '500';
    @Input() labelDescription: string;
    @Input() checked: boolean;
    @Input() disabled: boolean;
    @Input() value: string;
    @Input() tabIndex: number;
    @Input() ariaLabel: string;
    @Output() radioButtonChanged = new EventEmitter<string>();
}
